import { TelasIds } from "../../../../../common/utils/tela_ids";
import { IDeleteObraUseCase } from "../../../presentation/useCases/delete/delete_obra_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * DeleteObraUseCase
 */

export class DeleteObraUseCase implements IDeleteObraUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async deleteObra(
    idTela: TelasIds,
    idObra: number,
  ): Promise<void> {
    await this.repository.deleteObra(idTela, idObra);
  }
}
